<mat-dropdown
  [formControl]="formControl()"
  [options]="dropdownOptions()"
  [configurationInput]="formDropdownConfiguration"
  [isFormSubmitted]="isFormSubmitted()"
  [isLoading]="isLoading()"
  (search)="searchValue.set($event)"
></mat-dropdown>
